'use client'

const { createElement, useEffect, useRef } = require('react')

function DangerouslySetHtmlContent({
  html,
  dangerouslySetInnerHTML,
  allowRerender,
  isClient = true,
  scriptAllowedDomains = [],
  onBlockScript,
  ...rest
}) {
  // We remove 'dangerouslySetInnerHTML' from props passed to the div
  const divRef = useRef(null)
  const hasExecutedForClient = useRef(false)

  useEffect(() => {
    if (!html) throw new Error("html prop can't be null")
    if (!divRef.current) return

    // Atualiza o conteúdo HTML todas as vezes até isClient ser true
    const slotHtml = document.createRange().createContextualFragment(html)
    divRef.current.innerHTML = '' // Clear the container
    divRef.current.appendChild(slotHtml) // Append the new content

    // Executa os scripts apenas na primeira vez que isClient for true
    if (isClient && !hasExecutedForClient.current) {
      hasExecutedForClient.current = true

      const scripts = slotHtml.querySelectorAll('script')
      const blockedSrcs = []

      for (const element of scripts) {
        const src = element.getAttribute('src')
        if (
          src &&
          scriptAllowedDomains.length &&
          !scriptAllowedDomains.some((v) => src.indexOf(v) >= 0)
        ) {
          element.remove()
          blockedSrcs.push(src)
        }
      }

      if (
        blockedSrcs.length &&
        onBlockScript &&
        typeof onBlockScript === 'function'
      ) {
        onBlockScript(blockedSrcs)
      }
    }
  }, [html, isClient])

  return createElement('div', { ...rest, ref: divRef })
}

module.exports = DangerouslySetHtmlContent
